<!-- 音频标注模型校验区 -->
<template>
  <div class="audio-annotation-area">
    <div class="audio-header">
      <span class="span-current-time">{{currentTime}}</span>
        &nbsp;/&nbsp;
      <span class="span-total-time">{{totalTime}}</span>
      <span :class="['span-icon', 'icon-play-default']" @click="play()" title="播放"></span>
      <span :class="['span-icon', 'icon-pause-default']" @click="pause()" title="暂停"></span>
      <span :class="['span-icon', 'icon-stop-default']" @click="stop()" title="停止"></span>
      <div class="span-icon icon-outline">
        <div class="icon-volume" @click="onVolumeSwitch" title="音量"></div>
        <div class="block">
          <el-slider
            v-model="volume"
            @input="volumeInput">
          </el-slider>
        </div>
      </div>
      
      <!-- <div class="text-annotation-examples">
        <span @click="activeExamplePopup">标注示例</span>
      </div> -->
    </div>

    <!-- 音频时间 -->
    <div id="timeline" ref="timeline"></div>
    <!-- 音频波纹 -->
    <div id="waveform" ref="waveform"></div>

    <div class="audio-add-area">
      <div class="input-audio-time">
        <span class="input-audio-time-title">音频片段起止时间：</span>
        <el-input v-model="regionalTime.startTime" placeholder="开始时间" maxlength="12" size="mini" @blur="inputBlur('startBlur')" @keyup.enter.native="inputBlur('startBlur')"></el-input>
          &nbsp;-&nbsp;
        <el-input v-model="regionalTime.endTime" placeholder="结束时间" maxlength="12" size="mini" @blur="inputBlur('endBlur')" @keyup.enter.native="inputBlur('endBlur')"></el-input>
        <span class="span-reset" @click="onResetTime">重置</span>
      </div>

      <div class="button-all">
        <span class="span-button" @click="audition">试听</span>
        <span class="span-button" @click="addAudioList">添加到列表</span>
      </div>
    </div>

    <div class="table-header">
      <span>音频片段列表</span>
      <span @click="onClearAudioList">清空列表</span>
    </div>
    <el-table 
      :data="tableData"
      :header-cell-style="{background:'#DEE9F9',color:'#606266', borderColor:'#D9DFEA'}"
      style="width: 100%"
      height="171"
      tooltip-effect="dark"
      :row-class-name="tableRowClassName"
      stripe
      border>
      <el-table-column
        type="index"
        label="序号"
        width="60"
        align="center">
      </el-table-column>
      <!-- <el-table-column
        prop="labelName"
        label="音频片段名称"
        align="center">
      </el-table-column> -->
      <el-table-column
        label="音频片段起止时间"
        align="center">
        <template slot-scope="scope">
          <span>{{scope.row.startTime}}</span> &nbsp;-&nbsp; <span>{{scope.row.endTime}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <span class="column-audition" @click="handleAudition(scope.$index, scope.row)">试听</span>
          <!-- <span @click="handleEdit(scope.$index, scope.row)">编辑</span> -->
          <span class="column-delete" @click="handleDelete(scope.$index, scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="popup-list">
      <!-- 标注示例 -->
      <gat-popup
        :class="['popup-example', popupActive === 'example' ? 'on' : 'off']"
        :title="'标注示例'"
        @cancel="cancelPopup"
      >
        <template v-slot:content>
          <div class="example-box">
            <img
              src="../../../public/images/pretrain/annotation-examples.png"
              alt=""
            />
          </div>
        </template>
      </gat-popup>
      <!-- 清空标注列表提示 -->
      <gat-popup
        :class="[
          'popup-delete-audio popup-delete-audio-list',
          popupActive === 'delete'|| popupActive === 'label_delete' ? 'on' : 'off',
        ]"
        :title="popupActive === 'delete'? '清空列表':'删除音频片段'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="deletePicture"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span v-show="popupActive === 'label_delete'" class="title"
                >确定删除此音频片段吗？</span
              >
              <span v-show="popupActive === 'delete'" class="title"
                >确定清空列表的所有音频片段吗？</span
              >
            </div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js' // wavesurfer 音频波纹
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline'// Timeline音频时间显示插件
import Region from 'wavesurfer.js/dist/plugin/wavesurfer.regions'// regions音频选中区插件
import Cursor from 'wavesurfer.js/dist/plugin/wavesurfer.cursor' // cursor音频鼠标时间插件

import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'

export default {
  name: 'AudioAnnotationTestModelArea',
  components: { GatPopup, IconInfoHelp },
  props: {
    annotationsList: {
      type: Array,
      default: () => [],
    },
    regionAudio: {
      // 当前文件
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      wavesurfer: null,
      percent: null,
      speed: 1,
      audioListAll: [],
      tableData: [],
      currentTime: '00:00:00.000', // 当前播放时间
      totalTime: '00:00:00.000', // 音频总时长
      // 区域时间
      regionalTime: {
        startTime: '00:00:00.000',
        endTime: '00:00:01.000',
      },
      form: {
        id: '',
        labelName: '',
        startTime: '',
        endTime: '',
      },
      // selectLabel: {}, // 选中标签
      volume: 50, // 默认音量
      volumeState: true, // 音量开关状态 true:有音量
      popupActive: '',
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
        edite: {
          iconName: '修改',
          viewBox: '0 0 17 17',
          width: '14',
          height: '14',
        },
        delete: {
          iconName: '删除',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
          // iconColor: "#fff"}
        },
      },
    }
  },
  computed: {},
  watch: {
    annotationsList(val) {
      if (val && val.length) {
        this.audioListAll = val
      } else {
        this.wavesurfer.destroy() // 销毁waveform，移除事件，元素和关联节点
        this.init() // 加载频音实例
        this.regionalTime = {
          startTime: '00:00:00.000',
          endTime: '00:00:01.000',
        }
        this.currentTime = '00:00:00.000' // 当前播放时间
        this.totalTime = '00:00:00.000' // 音频总时长
        this.tableData = []
        this.currentRegion.remove() // 删除原有区域
      }
    },
    // 监测音频路径
    regionAudio(val) {
      if (val && val.imgUrl) {
        this.tableData = val.audioList
        this.load() // 执行绑定事件-加载音频

        this.regionalTime = {
          startTime: '00:00:00.000',
          endTime: '00:00:01.000',
        }
        this.currentTime = '00:00:00.000' // 当前播放时间
        this.currentRegion.remove() // 删除原有区域
        this.createRegion() // 创建音频选中区域
      } else {
        // this.wavesurfer.empty() // 清空waveform
        this.wavesurfer.destroy() // 销毁waveform，移除事件，元素和关联节点
        this.init() // 加载频音实例
        this.regionalTime = {
          startTime: '00:00:00.000',
          endTime: '00:00:01.000',
        }
        this.currentTime = '00:00:00.000' // 当前播放时间
        this.tableData = []
        this.currentRegion.remove() // 删除原有区域
      }

      this.$forceUpdate() // 强制更新数据
    },
  },
  created() {},
  mounted() {
    this.init() // 加载频音实例
  },
  methods: {
    // 当前音频标组列表去重
    unique(arr){            
      for(var i=0; i<arr.length; i++){
        for(var j=i+1; j<arr.length; j++){
          if(arr[i].id == arr[j].id){  //第一个等同于第二个，splice方法删除第二个
            arr.splice(j,1);
            j--;
          }
        }
      }
    return arr;
    },
    // 外部调用获取音频列表
    getAudioList() {
      // let audioListAll = JSON.parse(JSON.stringify(this.audioListAll))
      this.audioListAll.forEach(item => {
        let timesId = new Date().getTime().toString();
        let tableData = [{
          id: timesId,
          startTime: '00:00:00.000',
          endTime: this.changeTime(item.audioDurationTotal),
        }]

        if (item.audioId === this.regionAudio.audioId) {
          if (this.tableData && this.tableData.length > 0) {
            let arr = (item.audioList && item.audioList.length) ? item.audioList.concat(this.tableData) : this.tableData
            item.audioList = this.unique(arr) // 去重
          } else {
            item.audioList = tableData
            this.tableData = tableData
          }
        } else {
          if (item.audioList && item.audioList.length > 0) {
            item.audioList = item.audioList
          } else {
            item.audioList = tableData
          }
        }

        item.audioList.forEach(itn => {
          itn.audioUrl = item.imgUrl // 给每个标注添加音频路径
        });
      });

      return this.audioListAll;
    },

    // 创建标注方块元素
    createBlock() {
      setTimeout(() => {
        let wave = document.getElementsByTagName('wave')
        wave[0].style.overflow = 'visible'; // 去除超出范围隐藏样式

        // 创建左侧滑动方块
        let left = document.getElementsByClassName('wavesurfer-handle-start')
        if (left && left.length) {
          const $spanLeft = document.createElement('handle');
          $spanLeft.style.width = '10px';
          $spanLeft.style.height = '10px';
          $spanLeft.style.position = 'absolute';
          $spanLeft.style.left = '-8px';
          $spanLeft.style.bottom = '-10px';
          $spanLeft.classList.add('wavesurfer-handle-start');
          const $iLeft = document.createElement('i'); // 创建左侧三角
          $iLeft.style.width = '0';
          $iLeft.style.height = '0';
          $iLeft.style.borderBottom = '10px solid #10CD80';
          $iLeft.style.borderLeft = '10px solid transparent';
          $iLeft.style.position = 'absolute';
          $iLeft.style.left = '-8px';
          $iLeft.style.bottom = '0';
          // $iLeft.classList.add('wavesurfer-handle-start');
          left[0].appendChild($spanLeft);
          left[0].appendChild($iLeft);
        }

        // 创建右侧滑动方块
        let right = document.getElementsByClassName('wavesurfer-handle-end')
        if (right && right.length) {
          const $spanRight = document.createElement('handle');
          $spanRight.style.width = '10px';
          $spanRight.style.height = '10px';
          $spanRight.style.position = 'absolute';
          $spanRight.style.right = '-8px';
          $spanRight.style.bottom = '-10px';
          $spanRight.classList.add('wavesurfer-handle-end');
          const $iright = document.createElement('i'); // 创建右侧三角
          $iright.style.width = '0';
          $iright.style.height = '0';
          $iright.style.borderBottom = '10px solid #10CD80';
          $iright.style.borderRight = '10px solid transparent';
          $iright.style.position = 'absolute';
          $iright.style.right = '-8px';
          $iright.style.bottom = '0';
          // $iLeft.classList.add('wavesurfer-handle-end');
          right[0].appendChild($spanRight);
          right[0].appendChild($iright);
        }
      }, 10);
    },

    // 加载频音实例
    init() {
      this.wavesurfer = WaveSurfer.create({
        // container: this.$refs.waveform,//绑定容器，第一种方法
        // container: document.querySelector('#waveform'),//第二种方法
	      container: '#waveform',//第三种方法
        audioRate: this.speed, // 播放音频的速度。数字越低，速度越慢。
        forceDecode: true, // 在缩放时使用web audio强制解码音频，以获得更详细的波形。
        backgroundColor: '#2B3245', // 更改波形容器的背景颜色。
        waveColor: '#0084ff', // 波纹颜色
        progressColor: '#7bbaf9', // 播放波纹颜色
        cursorColor: '#7bbaf9', // 播放进度线颜色
        // backend: 'MediaElement', // WebAudio、MediaElement或MediaElementWebAudio。MediaElement是不受支持浏览器的后备方案。
        barWidth: 2, // 控制波纹宽度
        height: 120, // 波形的高度。以像素为单位测量。
        plugins: [
          Timeline.create({
            container: '#timeline',//绑定容器
            labelPadding: 2
          }),
          Region.create(),
          Cursor.create({
		      	showTime: true,
		      	opacity: 1,
		      	customShowTimeStyle: {
		      		'background-color': '#000',
		      		color: '#fff',
		      		padding: '2px',
		      		'font-size': '10px'
		      	}
		      })
        ],
      })

      this.createRegion() // 创建音频选中区域
      this.load() // 执行绑定事件-加载音频
    },
    // 创建音频选中区域
    createRegion(start, end) {
      this.currentRegion = this.wavesurfer.addRegion({
        // id: id, // region的id
        start: start ? start : 0, // region的开始位置，单位秒
        end: end ? end : 1, // region的结束位置，单位秒
        loop: false, // 播放完毕后是否循环播放
        // drag: false, // 是否支持拖拽
        // resize: false, // 是否支持改变region的大小
        color: "rgba(228, 207, 252, 0.2)", // 	region的颜色
      });

      // 初始化添加标注方块元素
      this.createBlock()
    },
    load() {
      let _this = this
      if (this.regionAudio.imgUrl) {
        this.wavesurfer.load(this.regionAudio.imgUrl) // 加载音频
      }

      // 加载时候
      this.wavesurfer.on('loading', (percents) => {
        // 当前加载的进度
        // console.log('当前加载的进度')
        this.percent = percents;
      })
      // 加载成功
      this.wavesurfer.on('ready', function() {
        // console.log('// 加载成功');
        _this.totalTime = _this.changeTime(_this.wavesurfer.getDuration()); // 获取音频总时长
      })
      // 播放中
      this.wavesurfer.on('audioprocess', function(e) {
      	_this.currentTime = _this.changeTime(_this.wavesurfer.getCurrentTime()) // 获取当前播放时间
      })
      // 结束播放
      this.wavesurfer.on("finish", () => {
        // _this.wavesurfer.pause();
      });

      // 区域点击
      this.wavesurfer.on('region-click', (region, mouseEvent)=> {
        // console.log('区域点击',region,mouseEvent);
        const { start, end } = region;
        _this.regionalTime = {
          startTime: _this.changeTime(start),
          endTime: _this.changeTime(end),
        };
      	// region.play() // 播放当前区域，另一种播放方式： this.wavesurfer.play(start, end)
      })
      // 区域创建
      this.wavesurfer.on('region-created', (region)=> {
        // console.log('区域创建',region);
      })
      // 区域更新
      this.wavesurfer.on('region-update', (region) => {
        // console.log('区域更新',region);
      })
      // 区域更新结束
      this.wavesurfer.on('region-update-end', (region) => {
        // console.log('区域更新结束',region);
        const { start, end } = region;
        _this.regionalTime = {
          startTime: _this.changeTime(start),
          endTime: _this.changeTime(end),
        };
      	/** 播放区域的两种方式 */
      	// this.wavesurfer.play(this.currentRegion.start, this.currentRegion.end)//①
      	// region.play();// ②
          
      	/** 新增区域列表 */
        //wavesurfer.regions.list:获取音频中的区域列表
      	_this.regionList = Object.values(_this.wavesurfer.regions.list);
      })
    },

    // 音量开关
    onVolumeSwitch() {
      return
      this.volumeState = !this.volumeState
      if (this.volumeState) {
        this.wavesurfer.setVolume(this.volume/100) // 设置音量0-1，0：静音
      } else {
        this.wavesurfer.setVolume(0) // 设置音量0-1，0：静音
      }
    },
    // 设置音量
    volumeInput(val) {
      this.wavesurfer.setVolume(val/100) // 设置音量0-1，0：静音
    },

    // 时间格式化 seconds/单位秒
    changeTime(seconds) {
    	seconds = Number(seconds);
      var hour = Math.floor(seconds / 60 / 60);
      var minutes = Math.floor(seconds / 60) % 60
        seconds = seconds % 60;
    	var secondsStr = Math.round(seconds).toString()
        secondsStr = seconds.toFixed(3);

      let hh = hour > 0 ? (hour < 10 ? '0' + hour : hour) : '00';
      let mm = minutes > 0 ? (minutes < 10 ? '0' + minutes : minutes) : '00';
      let ss = seconds < 10 ? '0' + secondsStr : secondsStr;
      
      return `${hh}:${mm}:${ss}`
    },

    // 时间格式处理：开始时间总秒数、结束时间总秒数
    getStartEndTimeSecond(data) {
      let starthh = data.startTime.split(':')[0] * 60 * 60,
       startmm = data.startTime.split(':')[1] * 60,
       startss = parseFloat(data.startTime.split(':')[2]);
      let endhh = data.endTime.split(':')[0] * 60 * 60,
       endmm = data.endTime.split(':')[1] * 60,
       endss = parseFloat(data.endTime.split(':')[2]);

      let start = starthh + startmm + startss;
      let end = endhh + endmm + endss;
      let timeSecond = {
        start,
        end
      };
      return timeSecond
    },

    // 输入时间片段失焦触发
    inputBlur(state) {
      let data = this.regionalTime;
      // let reg = /^[0-9]\d:[0-5]\d+[\.][0-9]{3}$/; // 判断字符串是否为时间格式： 00:00.000
      let reg = /^(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d+[\.][0-9]{3}$/; // 判断字符串是否为时间格式： 23:59:59.000
      let flng = state === 'startBlur' ? reg.test(data.startTime) : reg.test(data.endTime)

      if (flng) {
        let timeSecond = this.getStartEndTimeSecond(data); // 获取开始时间片段总秒数、结束时间片段总秒数
        let start = timeSecond.start;
        let end = timeSecond.end;

        let totalTimeList = this.totalTime.split(':');
        let mm = totalTimeList[0] * 60;
        let ss = (mm + totalTimeList[1]) * 60;
        let totalTimeSecond = ss + Number(totalTimeList[2]);
        // let totalTimeSecond = this.wavesurfer.getDuration(); // 获取音频总时长
        if (start > totalTimeSecond) {
          return this.$message.error('开始时间超出该音频总时长，请重新输入！');
        }
        if (end > totalTimeSecond) {
          return this.$message.error('结束时间超出该音频总时长，请重新输入！');
        }

        this.currentRegion.remove() // 删除原有区域
        if (start > end) {
          if (state === 'startBlur') {
            this.regionalTime.endTime = this.changeTime(start)
            this.createRegion(start, start) // 创建音频选中区域
          } else {
            this.regionalTime.startTime = this.changeTime(end)
            this.createRegion(end, end) // 创建音频选中区域
          }
        } else {
          this.createRegion(start, end) // 创建音频选中区域
        }
      } else {
        this.$message.error('时间格式不正确，正确格式为：23:59:59.000')
      }
    },

    // 重置选中音频片段时间
    onResetTime() {
      this.regionalTime = {
        startTime: '00:00:00.000',
        endTime: '00:00:01.000',
      }
      this.wavesurfer.pause() // 暂停音频
      this.currentRegion.remove() // 删除原有区域
      this.createRegion() // 创建音频选中区域
    },

    // 播放音频
    play(){
      this.wavesurfer.play()
    },
    // 暂停音频
    pause(){
      this.wavesurfer.pause()
    },
    // 停止音频回起点
    stop(){
      this.wavesurfer.stop()
      this.currentTime = '00:00:00.000'
    },
    // 试听选中音频片段
    audition(){
      let data = this.regionalTime;
      let timeSecond = this.getStartEndTimeSecond(data) // 获取开始时间片段总秒数、结束时间片段总秒数

      this.currentRegion.remove() // 删除原有区域
      this.createRegion(timeSecond.start, timeSecond.end) // 创建音频选中区域
      this.currentRegion.play()
    },
    // 添加音频片段
    addAudioList(){
      let data = this.regionalTime;
      let reg = /^(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d+[\.][0-9]{3}$/; // 判断字符串是否为时间格式： 23:59:59.000
      if (!reg.test(data.startTime) || !reg.test(data.endTime)) {
        return this.$message.error('时间格式不正确，正确格式为：23:59:59.000')
      }

      if (!this.regionAudio.imgUrl) {
        return this.$message.error('请先上传音频！')
      }
      if (this.regionalTime.endTime.indexOf('00:00:00.000') !== -1) {
        return this.$message.error('请选择音频片段！')
      }

      let flng = this.tableData.some(item => {
        return item.startTime === this.regionalTime.startTime && item.endTime === this.regionalTime.endTime
      });
      if (flng) {
        return this.$message.error('该音频片段已存在，请选择不同的音频片段！')
      }

      let timeSecond = this.getStartEndTimeSecond(data) // 获取开始时间片段、结束时间片段（单位秒）
      let start = timeSecond.start
      let end = timeSecond.end

      let totalTimeList = this.totalTime.split(':');
      let mm = totalTimeList[0] * 60;
      let ss = (mm + totalTimeList[1]) * 60;
      let totalTimeSecond = ss + Number(totalTimeList[2]);
      // let totalTimeSecond = this.wavesurfer.getDuration(); // 获取音频总时长
      if (start > totalTimeSecond) {
        return this.$message.error('开始时间超出该音频总时长，请重新输入！');
      }
      if (end > totalTimeSecond) {
        return this.$message.error('结束时间超出该音频总时长，请重新输入！');
      }
      if ((end - start) < 1) {
        return this.$message.error('音频片段不得小于1秒！')
      }

      this.form = {
        id: '',
        labelName: '',
        startTime: '',
        endTime: '',
      }

      let timesId = new Date().getTime().toString();
      let audioData = {
        id: timesId, // 标注id
        // labelId: this.selectLabel.labelId, // 标签id
        // labelName: this.selectLabel.labelName, // 标签名称
        startTime: this.regionalTime.startTime, // 音频标注区开始时间
        endTime: this.regionalTime.endTime, // 音频标注区结束时间
        // isShow: 1, // 1:标注显示
      }
      this.tableData.unshift(audioData)
    },

    tableRowClassName({ row, rowIndex }) {
    	// if (row.isShow == 1) { // 判断行isShow：1（显示）
    	// 	return ''
    	// }
    	// return 'warning-row'
    },
    // 列表试听
    handleAudition(index, row) {
      let data = this.tableData[index];
      let timeSecond = this.getStartEndTimeSecond(data); // 获取开始时间片段总秒数、结束时间片段总秒数

      this.currentRegion.remove() // 删除原有区域
      this.createRegion(timeSecond.start, timeSecond.end) // 创建音频选中区域
      this.currentRegion.play() // 播放区域音频
    },
    
    // 列表删除
    handleDelete(index, row) {
      // console.log(index, row);
      this.tableData.splice(index, 1);
      this.audioListAll.forEach(item => {
        if (item.audioId === this.regionAudio.audioId) {
          item.audioList = this.tableData
        }
      });
    },
    // 清空音频列表弹窗
    onClearAudioList() {
      this.popupActive = 'delete'
    },
    // 确认清空音频列表
    deletePicture() {
      this.audioListAll.forEach(item => {
        if (item.audioId === this.regionAudio.audioId) {
          item.audioList = []
        }
      });
      this.tableData = [];
      this.cancelPopup()
    },

    // 标注示例
    activeExamplePopup() {
      this.popupActive = 'example'
    },
    cancelPopup() {
      this.popupActive = ''
    },
  },
  beforeMount() {},
  updated() {},
  beforeDestroy() {
    this.wavesurfer.pause() // 暂停音频
  },
  destroyed() {},
}
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.audio-annotation-area {
  width: 100%;
  height: 500px;
  border: 1px solid #dde5f7;
  padding: 20px;

  .audio-header {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 12px;
    .span-current-time,
    .span-total-time {
      color: #333333;
      width: 92px;
      height: 24px;
      background: #F6F9FF;
      // border: 1px solid #CCD6F6;
      border-radius: 3px;
      text-align: center;
    }
    .span-total-time {
      margin-right: 22px;
    }
    .span-icon {
      // width: 17px;
      // height: 18px;
      margin-right: 10px;
      display: flex;
      cursor: pointer;
    }
    .icon-play-default {
      width: 15px;
      height: 18px;
      background: url('../../../public/images/icon-play-default.png') no-repeat;
      background-size: 100% 100%;
      &:hover {
        background: url('../../../public/images/icon-play-select.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .icon-pause-default {
      width: 17px;
      height: 16px;
      background: url('../../../public/images/icon-pause-default.png') no-repeat;
      background-size: 100% 100%;
      &:hover {
        background: url('../../../public/images/icon-pause-select.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .icon-stop-default {
      width: 18px;
      height: 18px;
      background: url('../../../public/images/icon-stop-default.png') no-repeat;
      background-size: 100% 100%;
      &:hover {
        background: url('../../../public/images/icon-stop-select.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .icon-play-select {
      background: url('../../../public/images/icon-play-select.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon-pause-select {
      background: url('../../../public/images/icon-pause-select.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon-stop-select {
      background: url('../../../public/images/icon-stop-select.png') no-repeat;
      background-size: 100% 100%;
    }

    .icon-outline {
      width: 17px;
      height: 17px;
      position: relative;
      .icon-volume {
        width: 100%;
        height: 100%;
        background: url('../../../public/images/icon-volume-default.png') no-repeat;
        background-size: 100% 100%;
      }
      &:hover {
        .block {
          display: inline-block;
        }
        .icon-volume {
          background: url('../../../public/images/icon-volume-select.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .block {
        width: 100px;
        display: none;
        position: absolute;
        top: -10px;
        right: -100px;
        padding-left: 10px;
        z-index: 9;
        &:hover {
          display: inline-block;
        }
        /deep/.el-slider__button {
          width: 8px;
          height: 8px;
        }
      }
    }

    .text-annotation-examples {
      position: absolute;
      top: 0;
      right: 0;
      span {
        float: right;
        color: #4c88ff;
        cursor: pointer;
      }
    }
  }

  #timeline {
    background: rgba(206, 221, 243, 0.26);
    // border-top: 1px solid #000;
    // border-right: 1px solid #000;
    border: 1px solid #DDE5F7;
  }
  #waveform {
    // background-color: #2B3245;
    position: relative;
    /deep/.wavesurfer-region {
      z-index: 3 !important;
      // background: rgba($color: #000000, $alpha: 0.3) !important;
    }
    /deep/.wavesurfer-handle-start,
    /deep/.wavesurfer-handle-end {
      // background: #e22020 !important;
      background: #10CD80 !important;
    }
  }

  .audio-add-area {
    color: #333333;
    height: 24px;
    // margin: 8px 0 10px;
    margin: 17px 0 ;
    line-height: 24px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .input-audio-time,
    .button-all {
      display: flex;
      align-items: center;
    }
    .input-audio-time {
      .input-audio-time-title {
        font-weight: bold;
      }
      /deep/.el-input--mini {
        width: 92px;
      }
      /deep/.el-input--mini .el-input__inner {
        color: #333333;
        font-size: 14px;
        border: 1px solid #CCD6F6;
        text-align: center;
        padding: 0;
        &:hover {
          border: 1px solid #3399FF;
        }
      }
      .span-reset {
        margin-left: 20px;
        cursor: pointer;
        &:hover {
          color: #3399FF;
        }
      }
    }
    .button-all {
      .span-button {
        margin-left: 15px;
        cursor: pointer;
        &:hover {
          color: #3399FF;
        }
      }
    }
  }

  .table-header {
    background: #FFFFFF;
    border-top: 1px solid #D9DFEA;
    border-left: 1px solid #D9DFEA;
    border-right: 1px solid #D9DFEA;
    padding: 14px 18px;
    display: flex;
    justify-content: space-between;
    span {
      color: #101013;
      font-size: 14px;
      &:last-child {
        color: #3399FF;
        cursor: pointer;
      }
    }
  }

  .el-table {
    // height: 190px;
    border: 1px solid #D9DFEA;
    box-shadow: 0px 4px 10px 0px rgba(109, 113, 171, 0.1);
    .column-audition,
    .column-delete {
      color: #3B87F9;
      font-size: 14px;
      cursor: pointer;
    }
    .column-audition {
      margin-right: 34px;
    }

    /deep/.warning-row {
      // background: #d9e2f8;
      display: none;
    }
  }
  /deep/.el-table--border th.gutter:last-of-type {
    background: #DEE9F9;
  }
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: rgba(231, 241, 255, 0.7);
  }
  /deep/.el-table td, .el-table th {
    height: 40px;
    padding: 0;
  }
  /deep/.el-table__body-wrapper .is-scrolling-none {
    background: #000;
  }
  /deep/.el-table__body-wrapper {
    height: 120px !important;
  }


  .popup-list {
    .popup-example {
      &.off {
        display: none;
      }
      &::v-deep .popup-inner {
        width: 900px;
        height: 420px;
      }
      .example-box {
        columns: 2;
        column-gap: 75px;
        -moz-column-rule: 1px solid #d8e5fd;
        -webkit-column-rule: 1px solid #d8e5fd;
        column-rule: 1px solid #d8e5fd;
        padding: 40px 20px 0;
        font-size: $font_size;
        .label-column {
          padding-bottom: 15px;
        }
        .txt {
          height: 100px;
          line-height: 30px;
        }
        b {
          color: $active_color;
          font-weight: normal;
        }
      }
      .example-box {
        padding: 20px 0;
        display: flex;
        justify-content: center;
        // align-items: center;
        img {
          width: 840px;
          height: 350px;
        }
      }
    }

    .popup-example {
      /deep/.popup-inner .popup-buttons {
        display: none;
      }
    }

    .popup-delete-audio {
      &.off {
        display: none;
      }
      &::v-deep .popup-head {
        border-bottom: 0 none;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          padding: 15px 0;
          text-align: center;
        }
      }
    }
    .popup-delete-audio-list {
      &::v-deep .popup-inner {
        width: 420px;
        height: 170px;
      }
      .popup-del-cnt {
        margin-top: 10px;
        .head {
          text-align: center;
         }
      }
    }
  }

}
</style>
